import { Footer } from '../../services/footer/models/footer.model';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { FooterService } from '../../services/footer/footer.service';
import { GetFooter } from './footer.actions';
import { Observable, tap } from 'rxjs';

export type FooterStateModel = Footer | null;

export const initialState = null;

@State<FooterStateModel>({
  name: 'footer',
  defaults: initialState,
})
@Injectable()
export class FooterState {
  private readonly footerService = inject(FooterService);

  @Selector()
  static footer(state: FooterStateModel) {
    return state;
  }

  @Action(GetFooter)
  getFooter(context: StateContext<FooterStateModel>, { locale }: GetFooter): Observable<Footer> {
    return this.footerService.getFooter(locale).pipe(
      tap((footer) => {
        context.setState(footer);
      }),
    );
  }
}
